import {GiftCard_Disable, GiftCard_Issue, GiftCard_List} from './backend'

const issueGiftCard = async cmd => {
  let {data} = await GiftCard_Issue({
    cmd: cmd,
  })
  return data
}

const disableGiftCard = async cmd => {
  let {data} = await GiftCard_Disable({
    cmd: cmd,
  })
  return data
}

const listGiftCards = async (page, pageSize, sortBy, text) => {
  let {data} = await GiftCard_List({
    sortBy: sortBy,
    page: page,
    pageSize: pageSize,
    text: text,
  })
  return data
}

export default {
  issueGiftCard,
  disableGiftCard,
  listGiftCards,
}
